import React, { useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const AddCashReceiveds = () => {
    const [staffId, setStaffId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = {
            staff_id: staffId,
            c_id: customerId,
            amount: amount,
            description: description
        };

        fetch(`${BASE_URL}cashreceived`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Cash received entry created successfully');
                    navigate('/CashReceivedList'); // Redirect to the list after successful creation
                } else {
                    alert('Failed to create cash received entry');
                }
            })
            .catch(error => console.error('Error:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Cash Received</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Cash Received Form */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add New Cash Received Entry</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="staffId" className="form-label">Staff ID</label>
                                        <input
                                            type="number"
                                            id="staffId"
                                            className="form-control"
                                            value={staffId}
                                            onChange={(e) => setStaffId(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customerId" className="form-label">Customer ID</label>
                                        <input
                                            type="number"
                                            id="customerId"
                                            className="form-control"
                                            value={customerId}
                                            onChange={(e) => setCustomerId(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            className="form-control"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddCashReceiveds;
